import { gql } from 'urql';
import { PRODUCT } from '../client';

// A single timestamped driver location fix on a route's breadcrumb trail.
// Hand-typed (not codegen) because the driverLocationTrail query is not yet in
// the stage-2 schema the type generator reads from.
export type DriverLocationPing = {
  id: string;
  latitude: number;
  longitude: number;
  occurredAt: string;
  accuracy?: number | null;
};

export type GetDriverLocationTrailQuery = {
  driverLocationTrail: DriverLocationPing[];
};

export const GET_DRIVER_LOCATION_TRAIL = gql`
  query ${PRODUCT}GetDriverLocationTrail($input: DriverLocationTrailInput!) {
    driverLocationTrail(input: $input) {
      id
      latitude
      longitude
      occurredAt
      accuracy
    }
  }
`;
